import $api from "../../../services/axiosService";
import { wrongAuthAunteficationAction } from "../aunteficationAction";
import { returnAuthAction } from "../../Auth/Thunk/checkAuthThunkAction";
import AuthService from "../../../services/AuthService";
import countly from "../../../../analytics/countly";
import { EVENT_NAMES } from "../../../../analytics/events";

export const authNumberThunkAction =
    (input, props, resetPassword = false) =>
        async (dispatch) => {
            try {
                const response = await $api.post("/v1.0/auth/code", input);

                if (response.status) {
                    localStorage.setItem(
                        "refreshToken",
                        response.data.refreshToken,
                    );
                    localStorage.setItem("token", response.data.token);

                    if (!resetPassword) {
                        const temp = await AuthService.getHeaderInformation({ dispatch });

                        if (temp) {
                            countly.setUser({
                                userId: input.userId,
                                pid: localStorage.getItem("pid"),
                            });
                            countly.event(EVENT_NAMES.LOGIN_SUCCESS, { pid: localStorage.getItem("pid") });
                            return dispatch(returnAuthAction());
                        } else {
                            dispatch(
                                wrongAuthAunteficationAction(
                                    "Что-то пошло не так, повторите попытку позже",
                                ),
                            );
                        }
                    } else if (resetPassword) {
                        localStorage.setItem("token", response.data.token);
                        localStorage.setItem(
                            "refreshToken",
                            response.data.refreshToken,
                        );
                        AuthService.getHeaderInformation({ dispatch }).then(r => console.log(r));

                        return dispatch(returnAuthAction());
                        // props.navigate('/reset-password')
                    }
                }
            } catch (e) {
                if (e.response) {
                    dispatch(wrongAuthAunteficationAction(e.response.data.detail));
                } else {
                    dispatch(
                        wrongAuthAunteficationAction(
                            "Что-то пошло не так, повторите попытку позже",
                        ),
                    );
                }
            }
        };
